module.exports = __webpack_public_path__ + "img/casa.c670e8b4.svg";